<!-- src/ChapterPage.vue -->

<template>
  <main>
    <ChapterPagePart1Content :id="id"/>
  </main>
</template>


<script>
  import ChapterPagePart1Content from '@/ChapterPagePart1Content.vue';
  import 'animate.css';
  export default {
    name: 'ChapterPage',
    props: ['id'], // ChapterNumber from the router (/chapter/a/:id)
    components: {
      ChapterPagePart1Content,
    },
  }

</script>
